export const foodCategories = [
  {
    value: "risottoPasta",
    label: "Risotto & Pasta",
    key: 0,
    primaryColor: "blue",
  },
  { value: "meatFish", label: "Meat & Fish", key: 1, primaryColor: "brown" },
  {
    value: "veggiesSides",
    label: "Veggies & Sides",
    key: 2,
    primaryColor: "green",
  },
  {
    value: "dessertsSweets",
    label: "Desserts & Sweets",
    key: 3,
    primaryColor: "yellow",
  },
];

export const initialMockedRecipes = [
  {
    id: "1",
    title: "Pasta alla carbonara",
    category: "risottoPasta",
    imageUrl:
      "https://images.unsplash.com/photo-1546549032-9571cd6b27df?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    date: "12/15/2022",
    ingredients: "Pasta, 200 gr; bacon, 1/2 cup;",
    instructions: "Cook the pasta and in another pan cook the bacon",
  },
  {
    id: "2",
    title: "Risotto con i funghi",
    category: "risottoPasta",
    imageUrl:
      "https://images.unsplash.com/photo-1637361874063-e5e415d7bcf7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    date: "9/5/2022",
    ingredients: "Rice, 1 cup; mushrooms, 1/2 cup;",
    instructions: "Cook the rice with broth and in the end add the mushrooms",
  },
  {
    id: "3",
    title: "Roastbeef",
    category: "meatFish",
    imageUrl:
      "https://images.unsplash.com/photo-1602540953134-e753ac78e81d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=735&q=80",
    date: "4/10/2021",
    ingredients: "Calf meat, 1 kg; bread, 1 piece; avocado, 1 piece;",
    instructions:
      "Cook the meat overnight and make a sandwich with the other ingredients",
  },
  {
    id: "4",
    title: "Polpo alla brace",
    category: "meatFish",
    imageUrl:
      "https://images.unsplash.com/photo-1526243070121-8040f7c9cc1c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80",
    date: "7/20/2021",
    ingredients: "Octopus, 1 piece; lemon juice;",
    instructions: "Cook the octopus and serve with a sprinkle of lemon juice",
  },
  {
    id: "5",
    title: "Patate arrosto",
    category: "veggiesSides",
    imageUrl:
      "https://images.unsplash.com/photo-1631898039984-fd5f61fe8732?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    date: "4/21/2022",
    ingredients: "Potato, 1 kg; extra virgin olive oil, 1 tbsp; salt, 1tsp;",
    instructions: "Cut the potatoes and bake them",
  },
  {
    id: "6",
    title: "Melanzane alla parmigiana",
    category: "veggiesSides",
    imageUrl:
      "https://images.unsplash.com/photo-1632229095740-8c75082087c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=735&q=80",
    date: "1/15/2023",
    ingredients: "Aubergines, 3; salt, 1/2 tsp;",
    instructions: "Cut the aubergines in slices and fry them",
  },
  {
    id: "7",
    title: "Zucchini Brownies",
    category: "dessertsSweets",
    imageUrl:
      "https://images.unsplash.com/photo-1607920591413-4ec007e70023?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    date: "1/15/2023",
    ingredients: "Zucchini, 2 cups; cacao powder, 1/2 cup;",
    instructions: "Mix the shredded with the cacao powder",
  },
  {
    id: "8",
    title: "Chocolate fondant",
    category: "dessertsSweets",
    imageUrl:
      "https://images.unsplash.com/photo-1600326145308-d7d5a04f4ce6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    date: "1/10/2023",
    ingredients: "Chocolate, 2 cups; cacao powder, 1/2 cup; Butter, 1 cup;",
    instructions:
      "Break the cookies and mix them with all the remaining ingredients and bake",
  },
];
